import React,{Component} from 'react'

const style={
  map:{
    border: '0',
    maxHeight: '370px',
    minHeight: '244px',
    height: '33vw',
    backgroundPosition:'center',
    backgroundRepeat:'no-repeat',
    animationDuration: '3s',
    animationFillMode: 'forwards',
    animationIterationCount: 'infinite',
    animationName: 'iframeLoadingBackground',
    animationTimingFunction: 'linear',
    background: 'linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%)',
    backgroundSize: '50% 104px',
    position: 'relative',
  },
}

export default class GoogleMap extends Component{
  render(){
    const {location}=this.props;
    const loc = escape(location).replace(',',/%2C/g);
    const src=`//www.google.com/maps/embed/v1/place?q=${loc}
        &zoom=14
        &key=AIzaSyDXmH5RXAK8QZfReeMzZA6aJ94I_cSNOOc
        &attribution_source=${document.title}`
    return(
      <div style={style.container}>
        <iframe
          title={`${document.title} Google Map`}
          id='googleMaps'
          style={style.map}
          src={`${src}`}
          width="100%"
          frameBorder="0"
          allowFullScreen={true}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/GoogleMap.js